<template>
  <v-card id="acceptance-arrival" class="pa-4 mb-4">
    <div class="text-subtitle-1 font-weight-medium mb-3">
      {{ $t("acceptance.arrival.title") }}
    </div>
    <v-row dense>
      <v-col cols="12" md="4">
        <v-text-field
          type="date"
          variant="outlined"
          density="comfortable"
          :label="`${$t('acceptance.arrival.date')} *`"
          :model-value="values['arrival.date']"
          :max="today"
          :readonly="readonly || frozen"
          :bg-color="bg('arrival.date')"
          :hint="$t('acceptance.arrival.date_hint', { date: todayLabel })"
          persistent-hint
          @update:model-value="change('arrival.date', $event)"
        />
        <correction-note
          group="arrival.date"
          :frozen="frozen"
          :corrections="corrections"
          :can-correct="canCorrect"
          :disabled="correctDisabled"
          @correct="$emit('correct', $event)"
          @open-log="$emit('open-log', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          variant="outlined"
          density="comfortable"
          :clearable="!readonly"
          :label="$t('acceptance.arrival.mode')"
          :items="modeItems"
          :model-value="values['arrival.mode']"
          :readonly="readonly"
          :bg-color="bg('arrival.mode')"
          @update:model-value="change('arrival.mode', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          variant="outlined"
          density="comfortable"
          :label="$t('acceptance.arrival.transporter')"
          :placeholder="$t('acceptance.arrival.transporter_placeholder')"
          :model-value="values['arrival.transporterName']"
          :readonly="readonly"
          :bg-color="bg('arrival.transporterName')"
          maxlength="120"
          @update:model-value="change('arrival.transporterName', $event)"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          variant="outlined"
          density="comfortable"
          :label="$t('acceptance.arrival.incoming_fir')"
          :placeholder="$t('acceptance.arrival.fir_placeholder')"
          :model-value="values['arrival.incomingFir']"
          :readonly="readonly"
          :bg-color="bg('arrival.incomingFir')"
          maxlength="60"
          @update:model-value="change('arrival.incomingFir', $event)"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "moment";
import { todayRome } from "@/components/Acceptance/draftForm.mjs";
import CorrectionNote from "@/components/Acceptance/correctionNote.vue";

const ARRIVAL_MODES = ["own_means", "tow_truck", "transporter", "other"]; // PROVISIONAL, as the API

export default {
  name: "AcceptanceArrivalCard",
  components: { "correction-note": CorrectionNote },
  props: {
    values: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
    highlight: { type: Array, default: () => [] },
    // Confirmed: some fields are frozen and change through a correction (corrections.mjs).
    frozen: { type: Boolean, default: false },
    corrections: { type: Object, default: () => ({}) },
    canCorrect: { type: Boolean, default: false },
    correctDisabled: { type: Boolean, default: false },
  },
  emits: ["change", "correct", "open-log"],
  computed: {
    today() {
      return todayRome();
    },
    todayLabel() {
      return moment(this.today, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    modeItems() {
      return ARRIVAL_MODES.map((value) => ({
        value,
        title: this.$t(`acceptance.arrival_modes.${value}`),
      }));
    },
  },
  methods: {
    bg(path) {
      return this.highlight.includes(path) ? "amber-lighten-5" : undefined;
    },
    change(path, value) {
      this.$emit("change", path, value);
    },
  },
};
</script>
